module.exports = __webpack_public_path__ + "img/invoice-template-au.f7eba76.png";